import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  heatingActive: boolean;
  coolingActive: boolean;
  plumbingActive: boolean;

  constructor() { }

  ngOnInit(): void {
    this.heatingActive = true;
    this.coolingActive = false;
    this.plumbingActive = false;
  }

  setService(service: string) {
    this.heatingActive = false;
    this.coolingActive = false;
    this.plumbingActive = false;

    switch (service) {
      case 'heating':
        this.heatingActive = true;
        break;

      case 'cooling':
        this.coolingActive = true;
        break;

      case 'plumbing':
        this.plumbingActive = true;
        break;
    };
  }

}
